/* esm.sh - unhead@3.1.0/dist/shared/unhead.DctB-0lW */
export * from "/*unhead@3.1.0/esnext/dist/shared/unhead.DctB-0lW.mjs";
